import { number } from 'prop-types';

const processBasicInformationPropTypes = {
  id: number.isRequired,
};

export default processBasicInformationPropTypes;
